var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardCrashanalysisIssuedetailTracelogFiltSearchIcon = function SvgNewcsDashboardCrashanalysisIssuedetailTracelogFiltSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_crashanalysis_issuedetail_tracelog_filt_search_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M553 146h12v12h-12z",
    "data-name": "\\u77E9\\u5F62 401"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_crashanalysis_issuedetail_tracelog_filt_search_icon_svg__a)",
    transform: "translate(-553 -146)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M558.099 146a5.1 5.1 0 0 1 4.006 8.257l2.718 2.718a.6.6 0 1 1-.848.849l-2.719-2.717a5.1 5.1 0 1 1-3.157-9.106Zm0 1.2a3.9 3.9 0 1 0 3.9 3.9 3.9 3.9 0 0 0-3.9-3.9"
  }))));
};
export default SvgNewcsDashboardCrashanalysisIssuedetailTracelogFiltSearchIcon;